var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[(_vm.summary)?_c('div',[_vm._v("Summary - "+_vm._s(_vm.summary.title))]):_vm._e(),_c('div',[(_vm.summary)?_c('TimeSliceCountChart',{attrs:{"chart-data":_vm.getChartData(_vm.summary.timeSliceCount),"title":`Event: ${_vm.summary.title}`}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }